import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { fabric } from "fabric";
import { saveAs } from "file-saver";
import useFabric from "../../hooks/useFabric";
import Header from "./header";
import Menu from "./menu";
import Canvas from "./canvas";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(100vh - 64px);
  background: #ccc;
`;

function Editor() {
  const fabricConfig = {
    height: 512,
    width: 512
  };
  const { fabricRef, canvas: fabricCanvas } = useFabric(fabricConfig);
  const [contextMenu, setContextMenu] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({});
  const addNew = data => {
    fabricCanvas.add(data);
    fabricCanvas.centerObject(data);
    fabricCanvas.setActiveObject(data);
    data.setCoords();
    fabricCanvas.renderAll();
  };

  const exportAsPNG = () => {
    fabricCanvas.renderAll();
    saveAs(
      fabricCanvas.toDataURL("png"),
      `image-${new Date().toISOString()}.png`
    );
  };

  const handleRightClick = e => {
    e.preventDefault();
    console.log(e);
    setContextMenu(true);
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
  };

  const deleteSelected = e => {
    const allActiveObjects = fabricCanvas.getActiveObjects();
    const currentObject = fabricCanvas.getActiveObject();
    if (allActiveObjects.length > 1) {
      e.preventDefault();
      allActiveObjects.forEach(object => {
        fabricCanvas.remove(object);
        fabricCanvas.discardActiveObject();
        if (fabricCanvas.item.length > 1) {
          fabricCanvas.setActiveObject(fabricCanvas.item(1));
        }
      });
    }
    if (allActiveObjects.length === 1) {
      // checks if the active object is text and it is being edited.
      if (currentObject.get("type") === "i-text" && currentObject.isEditing) {
        return;
      } else {
        e.preventDefault();
        fabricCanvas.remove(currentObject);
        fabricCanvas.discardActiveObject();
      }
    }
  };

  const deleteAll = e => {
    e.preventDefault();
    fabricCanvas.clear();
  };

  const selectAll = e => {
    e.preventDefault();
    fabricCanvas.discardActiveObject();
    const selection = new fabric.ActiveSelection(fabricCanvas.getObjects(), {
      canvas: fabricCanvas
    });
    fabricCanvas.setActiveObject(selection);
    fabricCanvas.requestRenderAll();
  };

  const bringToFront = e => {
    e.preventDefault();
    const activeObject = fabricCanvas.getActiveObject();
    fabricCanvas.bringToFront(activeObject);
    fabricCanvas.discardActiveObject();
    fabricCanvas.setActiveObject(fabricCanvas.item(0));
  };
  const sendToBack = e => {
    e.preventDefault();
    const activeObject = fabricCanvas.getActiveObject();
    fabricCanvas.sendToBack(activeObject);
    fabricCanvas.discardActiveObject();
    fabricCanvas.setActiveObject(fabricCanvas.item(1));
  };

  const handleKeyPress = e => {
    switch (e.keyCode) {
      case 8: {
        deleteSelected(e);
        break;
      }
      case 65: {
        (e.ctrlKey || e.metaKey) && selectAll(e); // ctrl + A or cmd + A
        break;
      }
      default: {
        return false;
      }
    }
  };
  useEffect(() => {
    window.addEventListener("contextmenu", handleRightClick, false);
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      // cleanup the added events
      window.removeEventListener("contextmenu", handleRightClick);
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [fabricCanvas]);
  return (
    <>
      <Header exportAsPNG={exportAsPNG} />
      <Container>
        <Menu addNew={addNew} exportAsPNG={exportAsPNG} />
        <Canvas
          canvasRef={fabricRef}
          // context menu props
          contextMenu={contextMenu}
          contextMenuPosition={contextMenuPosition}
          contextMenuClose={() => setContextMenu(false)}
          selectAll={selectAll}
          deleteSelected={deleteSelected}
          deleteAll={deleteAll}
          bringToFront={bringToFront}
          sendToBack={sendToBack}
        />
      </Container>
    </>
  );
}

export default Editor;
